import React from 'react';
import styled from 'styled-components';

import welcomeBackground from '../assets/WelcomeBackground.svg';

const WelcomeBackground = () => {
  return <div>
    {/*<Primer/>*/}
    <Background/>
  </div>
}

const Primer = styled.div`
  background: white;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

const Background = styled.div`
  background: white;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
`;

export default WelcomeBackground;
